import React from "react";
import { useState, useEffect } from "react";
import { VscBell } from "react-icons/vsc";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Skeleton from "react-loading-skeleton";
import NewInvDetailedView from "./NewInvDetailedView";
import CurrencyExchangeView from "./CurrencyExchange";
import { NOTIFICATION_TYPE_EXTENSION_INVESTOR_APPROVED, NOTIFICATION_TYPE_EXTENSION_INVESTOR_REJECTED, fundingClosedText, NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY, CRYPTO_SECRET_KEY,AUDITOR_ROLE } from "../utilities";
import CryptoJS from 'crypto-js'
import {
  base_url,
  NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS,
  NOTIFICATION_ENTITY_ADMIN,
  NOTIFICATION_ENTITY_INVESTOR,
  NOTIFICATION_ENTITY_BUSINESS,
  NOTIFICATION_TYPE_COMPLIANCE,
  NOTIFICATION_TYPE_INTEREST_SUBMITTED,
  NOTIFICATION_TYPE_PRE_CLOSURE_REQUEST,
  NOTIFICATION_TYPE_EXTEND_TENURE_REQUEST,
  NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REQUEST,
  NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION,
  LOAN_CURRENCY_TYPE_USD,
  NOTIFICATION_TYPE_KYC_SUBMITTED,
  NOTIFICATION_TYPE_WITHDRAWAL_REQUEST,
  NOTIFICATION_TYPE_FUNDING_80_PERCENT,
  NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED,
} from "../utilities";
import axios from ".././axios-interceptor";
import moment from "moment";
import Offcanvas from "react-bootstrap/Offcanvas";
import { io } from "socket.io-client";
import { FaUserCircle } from "react-icons/fa";
import { decrypt } from "../utils";
import Cookies from 'js-cookie';
import { clearAllCookies } from "../clearCookies";

// Multi-investor (Fund Now) notifications. Only reference_number (the loan ref no) is stored
// on these notifications, so the text cannot include amounts or names.
const multiInvestorNotificationText = (notifi) => {
  const ref = notifi.reference_number ? ` ${notifi.reference_number}` : "";
  switch (parseInt(notifi.notification_type)) {
    case NOTIFICATION_TYPE_WITHDRAWAL_REQUEST:
      return {
        heading: "Withdrawal requested",
        msgBody: `An investor has requested to withdraw their investment from loan${ref}. Review it in Investors > New Investment Interests.`,
      };
    case NOTIFICATION_TYPE_FUNDING_80_PERCENT:
      return {
        heading: "Opportunity 80% funded",
        msgBody: `Loan${ref} has reached 80% of its funding target.`,
      };
    case NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED:
      return {
        heading: "Opportunity fully funded",
        msgBody: `Loan${ref} is fully funded and ready to be disbursed to the business.`,
      };
    case NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY:
      return { heading: "Funding closed early", msgBody: `${fundingClosedText(notifi)}. Ready to be disbursed.` };
    // QA #41: the investor's decision on a tenure extension (reference = service request number).
    case NOTIFICATION_TYPE_EXTENSION_INVESTOR_APPROVED:
      return { heading: "Extension approved by investor", msgBody: `The investor approved the tenure extension request${ref}.` };
    case NOTIFICATION_TYPE_EXTENSION_INVESTOR_REJECTED:
      return { heading: "Extension rejected by investor", msgBody: `The investor rejected the tenure extension request${ref}.` };
    default:
      return null;
  }
};

const AdminNavBarMain = (props) => {
  let notifCount = props.count;

  const navigate = useNavigate();
  const [modalLoanDetailsShow, setModalLoanDetailsShow] = useState(false);

  const [heading, setHeading] = useState("");
  const [msgBody, setMsgBody] = useState("");
  const [notifType, setNotifType] = useState();
  const [notificationData, setNotificationData] = useState([]);
  const [notifId, setNotifId] = useState();
  const [notifrom, setNotifrom] = useState();
  let [notifLength, setNotifLength] = useState();

 
  
  useEffect(() => {
    const socket =
      window.location.hostname === "localhost"
        ? io("http://localhost:3051")
        : io(window.location.protocol + "//" + window.location.hostname, {
            path: "/restsocket3051/",
          });
    socket.on(NOTIFICATION_ENTITY_ADMIN, (notification) => {
      let notifi = notification.data;

      if (
        parseInt(notifi.notification_type) ===
        NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION
      ) {
        setHeading("New loan has been requested");
        setMsgBody(
          `${notifi.business_name} has requested a new loan for ${
            notifi.loan_currency === LOAN_CURRENCY_TYPE_USD
              ? "$\u00A0" + Number(notifi.loan_amount).toLocaleString()
              : "BHD " + Number(notifi.loan_amount).toLocaleString()
          } with Tenure ${
            notifi.loan_tenure === 1
              ? notifi.loan_tenure + " Month"
              : notifi.loan_tenure + " Months"
          }`
        );
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
        
      }
      if (
        parseInt(notifi.notification_type) ===
        NOTIFICATION_TYPE_EXTEND_TENURE_REQUEST
      ) {
        setHeading("Tenure extension requested");
        setMsgBody(
          `${notifi.business_name} has requested tenure extension for ${
            notifi.reference_number
          } for ${
            notifi.tenure === 1
              ? notifi.tenure + " Month"
              : notifi.tenure + " Months"
          }`
        );
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
      }
      if (
        parseInt(notifi.notification_type) ===
        NOTIFICATION_TYPE_PRE_CLOSURE_REQUEST
      ) {
        setHeading("Pre-closure requested");
        setMsgBody(
          `${notifi.business_name} has requested preclosure for loan ${
            notifi.reference_number
          } for ${moment(notifi.tenure).format("DD MMM YYYY")}`
        );
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
      }
      if (
        parseInt(notifi.notification_type) ===
        NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REQUEST
      ) {
        setHeading("Partial pre-payment requested");
        setMsgBody(
          `${
            notifi.business_name
          } has requested partial pre-payment of principal ${
            notifi.admin_request_loan_currency == LOAN_CURRENCY_TYPE_USD
              ? "$\u00A0" +notifi.partial_prepayment_amount
              : "BHD " + notifi.partial_prepayment_amount
          } for loan ${notifi.reference_number} for ${moment(
            notifi.tenure
          ).format("DD MMM YYYY")}`
        );
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
      }
      if (
        parseInt(notifi.notification_type) ===
        NOTIFICATION_TYPE_INTEREST_SUBMITTED
      ) {
        setHeading("Congratulations! investor has confirmed interest");
        setMsgBody(
          `An investor has sent an interest for this loan, ${notifi.reference_number}`
        );
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
      }
      if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_COMPLIANCE) {
        if (notifi.notify_from === NOTIFICATION_ENTITY_BUSINESS) {
          setHeading("New business requested");
          setMsgBody(
            `${notifi.business_name} has requested for onboarding to Bennefin`
          );
        } else if (notifi.notify_from === NOTIFICATION_ENTITY_INVESTOR) {
          setHeading("New investor requested");
          setMsgBody(
            `${
              ((notifi.investor_company_name !== "") && (notifi.investor_company_name !== null) && (notifi.investor_company_name !== undefined))
              ? notifi.investor_company_name
              : ((notifi.investor_name !== "") && (notifi.investor_name !== null) && (notifi.investor_name !== undefined))
              ? notifi.investor_name
              : "An investor"
            } has requested for onboarding to Bennefin`
          );
        }
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
        setNotifrom(notifi.notify_from);
      }
      if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_KYC_SUBMITTED) {
        if (notifi.notify_from === NOTIFICATION_ENTITY_BUSINESS) {
          setHeading("KYC form submitted");
          setMsgBody(
            `${notifi.business_name} has submitted KYC form`
          );
        } 
        if (notifi.notify_from === NOTIFICATION_ENTITY_INVESTOR) {
          setHeading("KYC form submitted");
          setMsgBody(
            `${notifi.investor_name} has submitted KYC form`
          );
        } 
        
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
        setNotifrom(notifi.notify_from);
      }
      if (
        parseInt(notifi.notification_type) ===
        NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS
      ) {
        setHeading("Business has agreed the terms and conditions");
        setMsgBody(
          `${notifi.business_name} has agreed terms and conditions for the loan ${notifi.reference_number} `
        );
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
      }
      const multiInvText = multiInvestorNotificationText(notifi);
      if (multiInvText) {
        setHeading(multiInvText.heading);
        setMsgBody(multiInvText.msgBody);
        setNotifType(notifi.notification_type);
        setNotifId(notifi.notification_id);
      }
      setShowNotif(true);
    });
    axios
      .post(base_url + "notifications/get_admin_notifications")
      .then((res) => {
        setNotificationData(res.data.data);
        setNotifLength(res.data.data.length);
      });
    return () => {
      socket.disconnect();
    };
  }, []);

  const [showNotif, setShowNotif] = useState(false);
  // const handleDismissNotif = () => {
  //   axios.post(base_url + "notifications/update_is_read_notification", {
  //     notification_id: notifId,
  //   });
  //   setShowNotif(false);
  // };
  const handleCloseNotif = () => setShowNotif(false);

  const [notificationList, setNotificationList] = useState([]);

  const handleCloseNotifmenu = (data) => {
    axios
      .post(base_url + "notifications/update_is_read_notification", {
        notification_id: data.notification_id,
      })
      .then((res) => {
        const mydata = notificationList.filter((item) => {
          return item.notification_id !== data.notification_id;
        });
        setNotificationList(mydata);
        setNotifLength(mydata.length);
      });
  };


  const handleViewDetails = () => {
    handleCloseNotif();
    axios
      .post(base_url + "notifications/update_is_read_notification", {
        notification_id: notifId,
      })
      .then((res) => {
        switch (parseInt(notifType)) {
          case NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION:
          case NOTIFICATION_TYPE_PRE_CLOSURE_REQUEST:
          case NOTIFICATION_TYPE_EXTEND_TENURE_REQUEST:
          case NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REQUEST:
            if (window.location.pathname === "/allservicerequests") {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              navigate("/allservicerequests");
            }
            break;
          case NOTIFICATION_TYPE_COMPLIANCE:
            if(notifrom === NOTIFICATION_ENTITY_BUSINESS){
            
              if (window.location.pathname === "/compliance" && 
              document.getElementById("onboarding-tab").classList.contains("active") &&
              document.getElementById("onboardingbusiness-tab").classList.contains("active")
              ) {
               
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              } else {
               
                navigate("/compliance");
                setTimeout(() => {
                  document.getElementById("onboarding-tab").classList.add("active");
                  document.getElementById("onboarding-tab-pane").classList.add("active");
                  document.getElementById("onboardingbusiness-tab").classList.add("active");
                  document.getElementById("onboardingbusiness-tab-pane").classList.add("active");

                  document.getElementById("business-tab").classList.remove("active");
                  document.getElementById("business-tab-pane").classList.remove("active");
                  document.getElementById("newinvestment-tab").classList.remove("active");
                  document.getElementById("newinvestment-tab-pane").classList.remove("active");
                    document.getElementById("onboardinginvestor-tab").classList.remove("active");
                    document.getElementById("onboardinginvestor-tab-pane").classList.remove("active")
                }, 200);
              }
             }
             if(notifrom === NOTIFICATION_ENTITY_INVESTOR){
              if (window.location.pathname === "/compliance"
               && document.getElementById("onboarding-tab").classList.contains("active") && 
              document.getElementById("onboardinginvestor-tab").classList.contains("active")
              ) {
                setTimeout(() => {
                  window.location.reload();
                }, 800);
              } else {
                navigate("/compliance");
                setTimeout(() => {
                  document.getElementById("onboarding-tab").classList.add("active");
                  document.getElementById("onboarding-tab-pane").classList.add("active");
                  document.getElementById("onboardinginvestor-tab").classList.add("active");
                  document.getElementById("onboardinginvestor-tab-pane").classList.add("active")
                  
                  document.getElementById("business-tab").classList.remove("active");
                  document.getElementById("business-tab-pane").classList.remove("active");
                  document.getElementById("newinvestment-tab").classList.remove("active");
                  document.getElementById("newinvestment-tab-pane").classList.remove("active");
                  document.getElementById("onboardingbusiness-tab").classList.remove("active");
                  document.getElementById("onboardingbusiness-tab-pane").classList.remove("active");
                   
                }, 200);
              }
             }
            break;
          case NOTIFICATION_TYPE_KYC_SUBMITTED:
             if(notifrom === NOTIFICATION_ENTITY_BUSINESS){
              if (window.location.pathname === "/compliance" 
              && document.getElementById("business-tab-pane").classList.contains("active")) {
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              } else {
                 
                navigate("/compliance");
                setTimeout(() => {
                  document.getElementById("business-tab").classList.add("active");
                  document.getElementById("business-tab-pane").classList.add("active");

                  document.getElementById("onboarding-tab").classList.remove("active");
                  document.getElementById("onboarding-tab-pane").classList.remove("active");
                  document.getElementById("onboardingbusiness-tab").classList.remove("active");
                  document.getElementById("onboardingbusiness-tab-pane").classList.remove("active");
                  document.getElementById("newinvestment-tab").classList.remove("active");
                  document.getElementById("newinvestment-tab-pane").classList.remove("active");
                    document.getElementById("onboardinginvestor-tab").classList.remove("active");
                    document.getElementById("onboardinginvestor-tab-pane").classList.remove("active")
                }, 200);
              }
             }
             if(notifrom === NOTIFICATION_ENTITY_INVESTOR){
              if (window.location.pathname === "/compliance" && 
              document.getElementById("newinvestment-tab").classList.contains("active")) {
                setTimeout(() => {
                  window.location.reload();
                }, 800);
              } else {
                navigate("/compliance");
                setTimeout(() => {
                  document.getElementById("newinvestment-tab").classList.add("active");
                  document.getElementById("newinvestment-tab-pane").classList.add("active");

                  document.getElementById("business-tab").classList.remove("active");
                  document.getElementById("business-tab-pane").classList.remove("active");
                  document.getElementById("onboarding-tab").classList.remove("active");
                  document.getElementById("onboarding-tab-pane").classList.remove("active");
                  document.getElementById("onboardingbusiness-tab").classList.remove("active");
                  document.getElementById("onboardingbusiness-tab-pane").classList.remove("active");
                    document.getElementById("onboardinginvestor-tab").classList.remove("active");
                    document.getElementById("onboardinginvestor-tab-pane").classList.remove("active")
                    
                }, 200);
              }
             }
            break;
          case NOTIFICATION_TYPE_EXTENSION_INVESTOR_APPROVED:
          case NOTIFICATION_TYPE_EXTENSION_INVESTOR_REJECTED:
            if (window.location.pathname === "/allservicerequests") {
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } else {
              navigate("/allservicerequests");
            }
            break;
          case NOTIFICATION_TYPE_WITHDRAWAL_REQUEST:
          case NOTIFICATION_TYPE_FUNDING_80_PERCENT:
          case NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED:
          case NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY:
            // Fund Now loans live in Investors -> New Investment Interests.
            Cookies.set("is_first_tab", false, { expires: 7 });
            if (window.location.pathname === "/admininvestors") {
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } else {
              navigate("/admininvestors");
            }
            break;
          case NOTIFICATION_TYPE_INTEREST_SUBMITTED:
          case NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS:
            if (window.location.pathname === "/admininvestors") {
              setTimeout(() => {
                window.location.reload();
                
              }, 50);
              setTimeout(() => {
                Cookies.set("is_first_tab",false,{ expires: 7 });
                document.getElementById("investors-tab").classList.remove("active");
                document.getElementById("newinvestment-tab").classList.add("active");
                document.getElementById("investors-tab-pane").classList.remove("active");
                document.getElementById("newinvestment-tab-pane").classList.add("active")
              },100)
              
             
            } else {
              navigate("/admininvestors");
              if (window.location.pathname === "/admininvestors") {
                navigate("/admininvestors");
              
                setTimeout(function() {
                
                  Cookies.set("is_first_tab",false,{ expires: 7 });
                  document.getElementById("investors-tab").classList.remove("active");
                  document.getElementById("newinvestment-tab").classList.add("active");
                  document.getElementById("investors-tab-pane").classList.remove("active");
                  document.getElementById("newinvestment-tab-pane").classList.add("active");
                }, 10); 
              }
              
              
            }
            break;
          default:
            break;
        }
      })
      .catch((e) => {});
  };
  const handleViewDetailsList = (data) => {
    handleCloseSideBar();
    axios
      .post(base_url + "notifications/update_is_read_notification", {
        notification_id: data.notification_id,
      })
      .then((res) => {
        switch (parseInt(data.notifType)) {
          case NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION:
          case NOTIFICATION_TYPE_PRE_CLOSURE_REQUEST:
          case NOTIFICATION_TYPE_EXTEND_TENURE_REQUEST:
          case NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REQUEST:
            if (window.location.pathname === "/allservicerequests") {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              navigate("/allservicerequests");
            }
            break;
          case NOTIFICATION_TYPE_COMPLIANCE:
            if (window.location.pathname === "/admindashboard") {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              navigate("/admindashboard");
            }
            break;
          case NOTIFICATION_TYPE_EXTENSION_INVESTOR_APPROVED:
          case NOTIFICATION_TYPE_EXTENSION_INVESTOR_REJECTED:
            if (window.location.pathname === "/allservicerequests") {
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } else {
              navigate("/allservicerequests");
            }
            break;
          case NOTIFICATION_TYPE_WITHDRAWAL_REQUEST:
          case NOTIFICATION_TYPE_FUNDING_80_PERCENT:
          case NOTIFICATION_TYPE_OPPORTUNITY_FULLY_FUNDED:
          case NOTIFICATION_TYPE_FUNDING_CLOSED_EARLY:
            // Fund Now loans live in Investors -> New Investment Interests.
            Cookies.set("is_first_tab", false, { expires: 7 });
            if (window.location.pathname === "/admininvestors") {
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } else {
              navigate("/admininvestors");
            }
            break;
            case NOTIFICATION_TYPE_INTEREST_SUBMITTED:
              case NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS:
                if (window.location.pathname === "/admininvestors") {
                  setTimeout(() => {
                    window.location.reload();
                    
                  }, 50);
                  setTimeout(() => {
                    Cookies.set("is_first_tab",false,{ expires: 7 });
                    document.getElementById("investors-tab").classList.remove("active");
                    document.getElementById("newinvestment-tab").classList.add("active");
                    document.getElementById("investors-tab-pane").classList.remove("active");
                    document.getElementById("newinvestment-tab-pane").classList.add("active")
                  },100)
                  
                 
                } else {
                  navigate("/admininvestors");
                  if (window.location.pathname === "/admininvestors") {
                    navigate("/admininvestors");
                  
                    setTimeout(function() {
                      Cookies.set("is_first_tab",false,{ expires: 7 });
                      document.getElementById("investors-tab").classList.remove("active");
                      document.getElementById("newinvestment-tab").classList.add("active");
                      document.getElementById("investors-tab-pane").classList.remove("active");
                      document.getElementById("newinvestment-tab-pane").classList.add("active");
                    }, 10); 
                  }
                  
                  
                }
                break;
              default:
            // Handle default case here, if needed
            break;
        }
      })
      .catch((e) => {});
  };

  useEffect(() => {
    const updatedNotificationList = notificationData
      ?.map((notifi) => {
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION
        ) {
          return {
            heading: "New loan has been requested",
            msgBody: `${notifi.business_name} has requested a new loan for ${
              notifi.loan_currency === LOAN_CURRENCY_TYPE_USD
                ? "$\u00A0" + Number(notifi.loan_amount).toLocaleString()
                : "BHD " + Number(notifi.loan_amount).toLocaleString()
            } with Tenure ${
              notifi.loan_tenure === 1
                ? notifi.loan_tenure + " Month"
                : notifi.loan_tenure + " Months"
            }`,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notification_id: notifi.notification_id,
          };
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_EXTEND_TENURE_REQUEST
        ) {
          return {
            heading: "Tenure extension requested",
            msgBody: `${
              notifi.business_name
            } has requested tenure extension for ${
              notifi.reference_number
            } for ${
              notifi.tenure == 1
                ? notifi.tenure + " Month"
                : notifi.tenure + " Months"
            }`,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notification_id: notifi.notification_id,
          };
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_PRE_CLOSURE_REQUEST
        ) {
          return {
            heading: "Preclosure requested",
            msgBody: `${
              notifi.business_name
            } has requested preclosure for loan ${
              notifi.reference_number
            } for ${moment(notifi.tenure).format("DD MMM YYYY")}`,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notification_id: notifi.notification_id,
          };
        }
        if (
          parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REQUEST
        ) {
          return {
            heading: "Partial pre-payment requested",
            msgBody: `${
              notifi.business_name
            } has requested partial pre-payment of principal ${
              notifi.admin_request_loan_currency == LOAN_CURRENCY_TYPE_USD
              ? "$\u00A0" +notifi.partial_prepayment_amount
              : "BHD " + notifi.partial_prepayment_amount
            } for loan ${notifi.reference_number} for ${moment(
              notifi.tenure
            ).format("DD MMM YYYY")}`,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notification_id: notifi.notification_id,
          };
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_INTEREST_SUBMITTED
        ) {
          return {
            heading: "Congratulations! investor has confirmed interest",
            msgBody: `An investor has sent an interest for this loan, ${notifi.reference_number}`,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notification_id: notifi.notification_id,
          };
        }
        if (
          parseInt(notifi.notification_type) === NOTIFICATION_TYPE_COMPLIANCE
        ) {
          if (notifi.notify_from === NOTIFICATION_ENTITY_BUSINESS) {
            return {
              heading: "New business requested",
              msgBody: `${notifi.business_name} has requested for onboarding to Bennefin`,
              notifType: notifi.notification_type,
              date: notifi.created_date_time,
              is_read: notifi.is_read,
              notification_id: notifi.notification_id,
            };
          }
          if (notifi.notify_from === NOTIFICATION_ENTITY_INVESTOR) {
            return {
              heading: "New investor requested",
              msgBody: `${
                ((notifi.investor_company_name !== "") && (notifi.investor_company_name !== null) && (notifi.investor_company_name !== undefined))
                ? notifi.investor_company_name
                : ((notifi.investor_name !== "") && (notifi.investor_name !== null) && (notifi.investor_name !== undefined))
                ? notifi.investor_name
                : "An investor"
              } has requested for onboarding to Bennefin`,
              notifType: notifi.notification_type,
              date: notifi.created_date_time,
              is_read: notifi.is_read,
              notification_id: notifi.notification_id,
            };
          }
        }
        if (
          parseInt(notifi.notification_type) === NOTIFICATION_TYPE_KYC_SUBMITTED
        ) {
          if (notifi.notify_from === NOTIFICATION_ENTITY_BUSINESS) {
            return {
              heading: "Business KYC form submitted",
              msgBody: `${notifi.business_name} has submitted a KYC from to Bennefin`,
              notifType: notifi.notification_type,
              date: notifi.created_date_time,
              is_read: notifi.is_read,
              notification_id: notifi.notification_id,
            };
          }
          if (notifi.notify_from === NOTIFICATION_ENTITY_INVESTOR) {
            return {
              heading: "Investor KYC form submitted",
              msgBody: `${
                ((notifi.investor_company_name !== "") && (notifi.investor_company_name !== null) && (notifi.investor_company_name !== undefined))
                ? notifi.investor_company_name
                : ((notifi.investor_name !== "") && (notifi.investor_name !== null) && (notifi.investor_name !== undefined))
                ? notifi.investor_name
                : "An investor"
              } has submitted a KYC from to Bennefin`,
              notifType: notifi.notification_type,
              date: notifi.created_date_time,
              is_read: notifi.is_read,
              notification_id: notifi.notification_id,
            };
          }
        }
        if (
          parseInt(notifi.notification_type) ===
          NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS
        ) {
          return {
            heading: "Business has agreed the terms and conditions",
            msgBody: `${notifi.business_name} has agreed terms and conditions for the loan ${notifi.reference_number}`,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notification_id: notifi.notification_id,
          };
        }
        const multiInvText = multiInvestorNotificationText(notifi);
        if (multiInvText) {
          return {
            ...multiInvText,
            notifType: notifi.notification_type,
            date: notifi.created_date_time,
            is_read: notifi.is_read,
            notification_id: notifi.notification_id,
          };
        }
        return null;
      })
      .filter((notifi) => notifi !== null);

    setNotificationList(updatedNotificationList);
  }, [notificationData]);

  const [showSideNav, setShowSideNav] = useState(false);
  const handleCloseSideBar = () => setShowSideNav(false);
  const handleShowSideBar = () => {
    axios
      .post(base_url + "notifications/get_admin_notifications")
      .then((res) => {
        setNotificationData(res.data.data);
        setNotifLength(res.data.data.length);
      });
    setShowSideNav(true);
  };

  const [role_code,setRoleCode]=useState(Cookies.get("role_code"));
  

  useEffect(()=>{
    if(role_code){
      const decryptedValueData = decrypt(role_code)
      setRoleCode(decryptedValueData);
    }
  },[])

  const handleLogout = () => {
    axios.post(base_url + "user/logout", {
      auth_refresh_token: Cookies.get("User_Refreshtoken_Admin"),
    });
    if(role_code===AUDITOR_ROLE){
     clearAllCookies();
      navigate("/auditorlogin");
    }
    else{
     clearAllCookies();
      navigate("/adminlogin");
    } 
  };


  return (
    <Navbar
      className="navbarTopAdmin"
      expand="lg"
      style={{ backgroundColor: "white", height: "65px" }}
    >
      <div className="p-0 nav_first_child  w-100">
        <Navbar.Brand className="ms-5">
          {(
            <img
              src="/images/newbluelogo260423.svg"
              alt="true"
              style={{ height: "70px", padding: "18px 22px 18px 0px " }}
            />
          ) || <Skeleton count={1} />}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            <div className="d-flex">
              <div className="bell_styl"  style={{
    pointerEvents: role_code === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: role_code === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                <div>
                  <div
                    onClick={handleShowSideBar}
                    className="position-relative"
                  >
                    <span className="notifCount">
                      {notifLength === 0 ? 0 : notifLength}
                    </span>
                    <img src="/images/bellwithout.svg" alt="" />
                  </div>
                </div>
              </div>
              <div className="dropdown  me-3">
                {Cookies.get("user_id") !== "" ? (
                  <div className="d-flex bell align-items-center gap-3">
                    <div>
                      {/* <FaUserCircle className="fs-3 mx-4"/> */}
                      <img
                        className="dropbtn"
                        src="/images/Ben_userProfile.svg"
                        alt="true"
                      />
                    </div>
                  </div>
                ) : (
                  <i className="fa-solid fa-user" />
                )}
                <div className="dropdown-content">
                  <a
                    style={{ color: "black", pointerEvents: role_code === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: role_code === AUDITOR_ROLE ? 0.5 : 1}}
                    onClick={() => setModalLoanDetailsShow(true)}
                  >
                    Currency Exchange
                  </a>
                  {/* <a href="#">My Profile</a> */}
                  <a onClick={handleLogout} href="">
                    Logout
                  </a>
                </div>
              </div>
              <CurrencyExchangeView
                show={modalLoanDetailsShow}
                onHide={() => setModalLoanDetailsShow(false)}
              />
            </div>
          </Navbar.Text>
        </Navbar.Collapse>
      </div>

      <Offcanvas
        placement="end"
        show={showNotif}
        onHide={handleCloseNotif}
        {...props}
        className="inv_notif"
      >
        <Offcanvas.Body className="p-3">
          <div>
            <div className="">
              <div>
                <div className="inv_notif_styl">
                  <div className="d-flex justify-content-between">
                    <div>
                      <h3 className="mb-1">{heading}</h3>
                    </div>
                    <img
                      src="/images/Cancel.svg"
                      alt=""
                      className="Cpointer"
                      onClick={handleCloseNotif}
                    />
                  </div>
                  <p className="notif_msg_heigt">{msgBody}</p>
                  <div className="d-flex gap-3 mt-2">
                    <span
                      className="toast_viewdetails"
                      onClick={handleViewDetails}
                    >
                      View Details
                    </span>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        placement="end"
        show={showSideNav}
        onHide={handleCloseSideBar}
        {...props}
        className="admin_notif_sidebar"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Notifications</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            {notificationList.length === 0 ? (
              <div className="text-center mt-5">No new notification</div>
            ) : (
              notificationList.map((notif) => {
                return (
                  <div key={notif.ref_no} className="">
                    <div className="Indiv_notif_styl">
                      <div className="inv_notif_styl">
                        <div className="d-flex justify-content-between">
                          <div>
                            <h3 className="mb-1">
                            <b className="text-primary fs-5">&#x2022; </b>
                            {notif.heading}</h3>
                          </div>
                        </div>
                        <p className="notif_msg_heigt">{notif.msgBody}</p>
                        <div className="d-flex gap-3 mt-2">
                          <span
                            className="toast_viewdetails"
                            onClick={() => handleViewDetailsList(notif)}
                          >
                            View Details
                          </span>
                          <span
                            className="toast_dismiss"
                            onClick={() => handleCloseNotifmenu(notif)}
                          >
                            Dismiss
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </Navbar>
  );
};

export default AdminNavBarMain;
